import { createFileRoute } from "@tanstack/react-router";
import ErrorComponent from "@/components/blocks/error-component";
import { getAllBlogs, getFeaturedBlogs } from "@/lib/utils/blog.utils";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/blog/")({
	head: () =>
		generateSeo({
			title: "CraftLayer Blog | Web Development & SEO Insights Bangalore",
			description:
				"Read the latest articles from the CraftLayer team. Expert insights on Next.js, web design, UI/UX trends, and SEO best practices to help Bangalore businesses grow.",
			url: "/blog",
			keywords: [
				"web development blog",
				"Next.js tutorial",
				"UI/UX trends",
				"software engineering articles",
				"CraftLayer blog",
				"digital marketing tips",
				"bangalore tech blog",
			],
		}),
	loader: async () => {
		const [allBlogs, featuredBlogs] = await Promise.all([
			getAllBlogs(),
			getFeaturedBlogs(),
		]);
		return { allBlogs, featuredBlogs };
	},
	errorComponent: ErrorComponent,
});
